import { Container, Row, Col, Card, Table } from "react-bootstrap";
import { AnimatedPage } from "../../core/AnimatedPage";
import SliderButton from "../../core/SliderButton";

import whyUs from "../../images/home/why-us.png";
import client1 from "../../images/clients/1.webp";
import client2 from "../../images/clients/2.webp";
import client3 from "../../images/clients/3.webp";
import client4 from "../../images/clients/4.webp";
import client5 from "../../images/clients/5.webp";
import client6 from "../../images/clients/6.webp";
import client7 from "../../images/clients/7.webp";
import client8 from "../../images/clients/8.webp";
import client9 from "../../images/clients/9.webp";
import client10 from "../../images/clients/10.webp";
import client11 from "../../images/clients/11.webp";
import client12 from "../../images/clients/12.webp";

// ---------- Section: Why Us ----------
export const WhyUs = () => {
  return (
    <section
      className="py-5"
      aria-labelledby="why-us-heading"
    >
      <Container>
        <Row className="align-items-center g-4">
          <Col lg={5}>
            <img
              src={whyUs}
              alt="High1Digital student"
              className="img-fluid rounded"
              loading="lazy"
            />
          </Col>

          <Col
            lg={7}
            className="p-4"
          >
            <h2 id="why-us-heading">Why Us?</h2>
            <ul
              style={{
                lineHeight: 1.9,
                listStyleType: "none",
                margin: 0,
                padding: 0,
              }}
            >
              <li>
                <strong style={{ color: "red" }}>High1Digital:</strong> Your
                Digital Success Partner.
              </li>
              <li>
                <strong style={{ color: "red" }}>
                  Dedicated to Excellence:
                </strong>{" "}
                We are committed to delivering top-notch digital marketing
                services tailored to your unique needs.
              </li>
              <li>
                <strong style={{ color: "red" }}>Niche Techniques:</strong>{" "}
                Utilizing specialized strategies and cutting-edge tools for
                maximum impact in the digital landscape.
              </li>
              <li>
                <strong style={{ color: "red" }}>Innovative Solutions:</strong>{" "}
                Our passionate team goes beyond the conventional, providing
                creative and effective approaches to propel your brand forward.
              </li>
              <li>
                <strong style={{ color: "red" }}>Results-Driven:</strong> At
                High1Digital, we measure success by the tangible results we
                achieve for our clients – your triumph is our ultimate goal.
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

// ---------- Section: What You Get (table/cards) ----------
const featureRows = [
  {
    feature: "EduPilot Admissions Portal",
    description:
      "Centralized CRM to track every inquiry, visit, and admission.",
  },
  {
    feature: "WhatsApp Automation Setup",
    description:
      "Personalized message flows for follow-ups, reminders, and event invites.",
  },
  {
    feature: "Lead Routing & Integration",
    description:
      "Directly connect Meta, Google, and Website forms to your CRM.",
  },
  {
    feature: "Dedicated Tech Support",
    description:
      "Ongoing assistance for all technical and portal-related queries.",
  },
  {
    feature: "Performance Reports",
    description:
      "Weekly summaries of leads, visit status, and counselor performance.",
  },
];

export const WhatYouGet = () => {
  return (
    <section
      className="py-5 bg-light"
      aria-labelledby="what-you-get-heading"
    >
      <Container>
        <h3
          id="what-you-get-heading"
          className="mb-4 text-center"
        >
          What you get?
        </h3>

        {/* md+ -> table; sm -> stacked cards */}
        <div className="d-none d-md-block">
          <Table
            responsive="md"
            hover
            bordered
            className="align-middle"
          >
            <thead className="table-dark">
              <tr>
                <th style={{ width: "30%" }}>Feature</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {featureRows.map((r, i) => (
                <tr key={i}>
                  <td>
                    <strong>{r.feature}</strong>
                  </td>
                  <td>{r.description}</td>
                </tr>
              ))}

              <tr>
                <td>
                  <strong>Image Suggestions</strong>
                </td>
                <td>
                  Show portal dashboards, WhatsApp chats, or school admission
                  desks (replace old laptop/business images).
                </td>
              </tr>
            </tbody>
          </Table>
        </div>

        <div className="d-block d-md-none">
          <Row className="g-3">
            {featureRows.map((r, i) => (
              <Col
                xs={12}
                key={i}
              >
                <Card className="shadow-sm">
                  <Card.Body>
                    <Card.Title as="h6">
                      <strong>{r.feature}</strong>
                    </Card.Title>
                    <Card.Text>{r.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}

            <Col xs={12}>
              <Card className="shadow-sm">
                <Card.Body>
                  <Card.Title as="h6">
                    <strong>Image Suggestions</strong>
                  </Card.Title>
                  <Card.Text>
                    Show portal dashboards, WhatsApp chats, or school admission
                    desks (replace old laptop/business images).
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

// OurServices.jsx

export const OurServices = () => {
  const SERVICES = [
    {
      title: "Meta & Google Ad Campaigns",
      desc: "We create and manage campaigns designed to generate quality admission leads for your school or college.",
    },
    {
      title: "Landing Page Creation",
      desc: "High-converting admission landing pages built to convert inquiries into booked visits.",
    },
    {
      title: "WhatsApp Marketing Automation",
      desc: "Automated message sequences to engage parents and nurture leads until they visit your campus.",
    },
    {
      title: "Email Marketing Automation",
      desc: "Customized drip campaigns for parents who don’t respond immediately to calls or WhatsApp.",
    },
    {
      title: "CRM Integration & Dashboard Setup",
      desc: "End-to-end system setup to manage leads, counselor tracking, and daily performance.",
    },
    {
      title: "Ad Optimization & Reporting",
      desc: "Continuous ad monitoring and weekly performance updates to lower cost per admission.",
    },
    {
      title: "EduPilot Portal & Tech Support",
      desc: "End-to-end admissions tracking platform with ongoing technical support.",
    },
  ];

  return (
    <AnimatedPage>
      <section
        aria-labelledby="our-services-heading"
        className="py-5"
      >
        <Container>
          <h2
            id="our-services-heading"
            className="text-center mb-4"
          >
            Our Services for Educational Growth
          </h2>

          {/* Table for md+ screens */}
          <div className="d-none d-md-block mb-4">
            <Card className="shadow-sm">
              <Card.Body>
                <Table
                  responsive
                  bordered
                  hover
                  className="mb-0 align-middle"
                >
                  <thead className="table-dark">
                    <tr>
                      <th style={{ width: "30%" }}>Service</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {SERVICES.map((s, i) => (
                      <tr key={i}>
                        <td style={{ verticalAlign: "middle" }}>
                          <strong>{s.title}</strong>
                        </td>
                        <td>{s.desc}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </div>

          {/* Cards grid for xs -> md */}
          <div className="d-block d-md-none">
            <Row className="g-3">
              {SERVICES.map((s, i) => (
                <Col
                  xs={12}
                  key={i}
                >
                  <Card className="h-100 shadow-sm">
                    <Card.Body>
                      <Card.Title
                        as="h5"
                        className="mb-2"
                      >
                        {s.title}
                      </Card.Title>
                      <Card.Text className="mb-0">{s.desc}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          {/* Footer tagline */}
          <div className="text-center mt-4">
            <p
              className="mb-0 fw-semibold"
              style={{ fontSize: "1rem" }}
            >
              <strong>
                All our services come under our Done-For-You (DFY) model —
              </strong>{" "}
              so you focus on counseling, while we handle your entire marketing
              system.
            </p>
          </div>
        </Container>
      </section>
    </AnimatedPage>
  );
};

// ---------- Section: Clients ----------
export const ClientsSection = () => {
  const clients = [
    client1,
    client2,
    client3,
    client4,
    client5,
    client6,
    client7,
    client8,
    client9,
    client10,
    client11,
    client12,
  ];

  // minimal horizontal marquee slider using CSS animation would go into CSS.
  // For now we render a responsive grid and also a repeat track for marquee if you have CSS for .client-slider
  return (
    <section
      className="py-5 bg-white"
      aria-labelledby="clients-heading"
    >
      <Container>
        <h2
          id="clients-heading"
          className="text-center mb-4"
        >
          Our Clients
        </h2>

        {/* TODO: UPDATE CLIENT IMAGES */}
        {/* Grid of client logos */}
        <div className="d-flex g-3 justify-content-center marquee-container">
          {clients.map((c, i) => (
            <Col
              key={i}
              xs={6}
              sm={4}
              md={3}
              lg={2}
              className="d-flex align-items-center justify-content-center p-2"
            >
              <img
                src={c}
                alt={`client-${i}`}
                className="img-fluid"
                style={{ maxHeight: 150 }}
                loading="lazy"
              />
            </Col>
          ))}
        </div>
      </Container>
    </section>
  );
};

// ---------- Page Compose: Content ----------
export const Content = () => {
  return (
    <>
      <AnimatedPage>
        {/* Banner requires three images - use the same header images you used earlier */}

        <WhyUs />

        <WhatYouGet />
        <OurServices />
        <Container className="pt-5">
          <div className="d-flex justify-content-center my-5 px-3">
            <div className="w-100 w-md-75">
              <SliderButton />
            </div>
          </div>
        </Container>

        <ClientsSection />
      </AnimatedPage>
    </>
  );
};

export default Content;
